module.exports = __webpack_public_path__ + "static/media/background.d6a80563.jpg";